import type { ListBuilderList } from '../../../types';
import { createStandardOrderClientEmbeddedColumns } from '../columns';
import { ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS } from '../shared';

/**
 * Client Embedded Web Carts list configuration
 * Draft orders (carts) created today in E-Commerce (embedded in client view)
 */
export const clientEmbeddedWebCartsList: ListBuilderList = {
	id: 'client-embedded-web-carts',
	cacheTTL: 600000,
	name: "Today's Web Carts",
	type: 'default',
	active: true,
	sortOrder: 5,
	requiredFeature: 'ecommerce',
	columns: createStandardOrderClientEmbeddedColumns(),
	description: 'Draft orders (carts) created today in E-Commerce',
	defaultSortId: 'column-dates-desc',
	requiredFields: ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS,
	filterRules: {
		orderDateRange: {
			defaultValue: [
				{
					id: 'today',
					label: 'Today',
					data: {
						startDate: '{{DATE:0d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
		orderStatus: {
			defaultValue: [{ id: '1', label: 'Unsubmitted' }],
		},
		orderOrigin: {
			defaultValue: [{ id: '3', label: 'E-Commerce' }],
		},
	},
};
